import { render, staticRenderFns } from "./myDialog.vue?vue&type=template&id=d27a28da&scoped=true&"
import script from "./myDialog.vue?vue&type=script&lang=js&"
export * from "./myDialog.vue?vue&type=script&lang=js&"
import style0 from "./myDialog.vue?vue&type=style&index=0&id=d27a28da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27a28da",
  null
  
)

export default component.exports